import { Button, Modal, Input, Select, DatePicker, InputNumber,Form,Radio,notification, Checkbox, Space} from 'antd'
import { type } from 'os';
import { useEffect, useState } from 'react'
import SweetAlert from "react-bootstrap-sweetalert";
import {useAtom} from 'jotai'
import { retirementQuantity, selectedRecord,accessTokenAtom } from "../atoms";
import NetworkService from '../services/NetworkService';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import {  useMsal } from '@azure/msal-react';




const RetirementModal = ({ currentTabTitle,display,setDisplay,energyPlans,token }) => {
  const [accessAtom,setAPIAtom]=useAtom(accessTokenAtom)
    const [isModalOpen, setIsModalOpen] = useState(display)
    const [customerName,setCustomerName]=useState();
    const [MSSL,setMSSL]=useState();
    const [checked, setChecked] = useState(false);
    
    const [projectCost,setprojectCost]=useState()
    const [totalQuantity,settotalQuantity]=useState()
    const [inputModal,setInputModal]=useState(false)
    const [currentRecord,setCurrentRecord]=useAtom(selectedRecord)
    const [retirementQty]=useAtom(retirementQuantity)
    const [api, contextHolder] = notification.useNotification();
    const [energyPickedPlans,setEnergyPickedPlans]=useState([]);
    const [form] = Form.useForm();
    const customerGroupValue = Form.useWatch('customerGroup', form);
    const initialDate = Form.useWatch('retirementStart', form);
    const { instance, accounts } = useMsal();

  //   const layout = {
  //     labelCol: { xs: { span: 24 }, sm: { span: 12 }, md: { span: 8 }, lg: { span: 8 } },
  //     wrapperCol: { xs: { span: 24 }, sm: { span: 12 }, md: { span: 12 }, lg: { span: 12 } }
  // }

  useEffect(()=>{
    form.resetFields(["retirementEnd"])
  

  },[initialDate])

  useEffect(()=>{

    const energyToPick=energyPlans.filter((i)=>{
      if(customerGroupValue=="Business User"){
        if(currentRecord?.typeOfGreenInstrument=="CC"){
          return i.planName.toLowerCase().includes("go green");
        }else if(currentRecord?.typeOfGreenInstrument=="REC"){
          return i.planName.toLowerCase().includes("go clean");
        }
        else {
          return i.planName.toLowerCase().includes("biz sunny");
        }
        //return i.customerGroup=="C&I";
      }else if(customerGroupValue=="Residential User"){
        if(currentRecord?.typeOfGreenInstrument=="CC"){
          return i.planName.toLowerCase().includes("power eco cc") || i.planName.toLowerCase().includes("get it green");
        }else if(currentRecord?.typeOfGreenInstrument=="REC"){
          return i.planName.toLowerCase().includes("power eco rec") || i.planName.toLowerCase().includes("get sunny");
        }
        //return i.customerGroup=="Residential"
      }
    })

    form.resetFields(["productName"])
    setEnergyPickedPlans(energyToPick)

  },[customerGroupValue])
    

    const showModal = () => {
        setIsModalOpen(true)
    }

    const onCheckChange = (e) => {
      console.log('checked = ', e.target.checked);
      setChecked(e.target.checked);
    };

    const openNotification = (certlink, generateCertificate) => {
      const btn = generateCertificate ? (
        <Space>
          <Button type="primary" size="small" onClick={() => notificationyes(certlink, generateCertificate)}>
            Yes
          </Button>
          <Button type="primary" size="small" onClick={() => notificationno()}>
            No
          </Button>
        </Space>
      ) : (
        <Space>
          <Button type="primary" size="small" onClick={() => notificationno()}>
            Close
          </Button>
        </Space>
      );
      api.success({
        message: `Added Successfully`,
        description:
        generateCertificate ? (<span>Certificate Link:  <a href={certlink} target="_blank" rel="noreferrer"> Link </a> <br />Send Email?</span> ) : 
        (<span>Certificate Link: Certificate Not Generated</span> ) ,
        placement:'top',
        btn,
        duration:0,
        onClose:(()=>{        
          window.location.reload(false);
        })
      });
    };

    const notificationyes = (certlink) => {
      const networkServiceObj = new NetworkService();
      let certno = certlink.substring(certlink.indexOf('=') + 1,certlink.indexOf('&'))
      networkServiceObj.queueCertificateEmail(certno,token)
      .then(response=> {        
          if(response.messageCode==200){
            networkServiceObj.sendCertificateEmail(token).then(response2=> { 
              api.destroy();
              window.location.reload(false);
            })              
          }
      })
    }
    const notificationno = () => {
      api.destroy();
      window.location.reload(false);
    }

 
    const handleCancel = () => {
        form.resetFields();
        setDisplay(false)
    }
    const date = new Date();

    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

// This arrangement can be altered based on how we want the date's format to appear.
// let currentDate = `${day}-${month}-${year}`;



const onFinish = (values) => {
  const date = new Date();
  let retirementstart = values.retirementStart !== undefined ? values['retirementStart'].format('YYYY-MM-DD') : null;
  let retirementend = values.retirementEnd !== undefined ? values['retirementEnd'].format('YYYY-MM-DD') : null;
  let energyInfo=values.productName ? JSON.parse(values.productName) : null;
  let inputBody={
    id:uuidv4(),
    retirementType: currentRecord.typeOfGreenInstrument,
    serialNumber: "",
    customerType: values.customerGroup,
    customerName: values.customerName,
    emailAddress:values.emailAdd,
    mssl: values.mssl ?? null,
    accountNumber: values.businessNo ?? "",
    contractNumber: values.contractNo ?? "",
    productName: energyInfo ? energyInfo.energyPlanName : "",
    energyPlanId: energyInfo ? energyInfo.energyId : null, // <--- ID FOR ENERGY PLAN
    revenue: values.revenue.toString(),
    retiredDate: moment(date).format('YYYY-MM-DD'),
    retirementPeriodStart: retirementstart,
    retirementPeriodEnd: retirementend,
    cost: values.cost,
    quantity: values.quantity,
    consumption : values.Consumption ?? null,
    cumulativeQuantity: 0,
    remarks: values.remarks ?? "",
    activeSerialNumber: values.serialNo,
    createdDate: date,
    createdBy: accounts[0].name,
    modifiedDate: date,
    modifiedBy: accounts[0].name,
    generateCertificate: values.generateCertificate  
  }

  const networkServiceObj = new NetworkService();
  networkServiceObj.addRetirementService(inputBody,token)
  .then(response=> {
    
    if(response.result.messageCode==201){  
        setDisplay(false);
        openNotification(response.result.data, values.generateCertificate)
    }
})
  };
  const onFinishFailed = (errorInfo) => {
    
  };

    return (
        <>
        {contextHolder}
            <Modal
                title={`Create New ${currentRecord?.typeOfGreenInstrument} Batch Retirement`}
                open={display}
                onCancel={handleCancel}
                width={'50%'}

                footer={[
                    <Button key="back" onClick={handleCancel}>
                        Return
                    </Button>,
                    <Button form="retirementForm" key="submit" type="primary" htmlType="submit">
                        Submit
                    </Button>,
                ]}
            >
                <div className='py-4'>
                <Form
                    id="retirementForm"
                    name="basic"
                    form={form}
                    labelCol={{span:6}}
                    labelAlign={"left"}
                    wrapperCol={{
                    span: 8,
                    }}
                    style={{width:'100%'}}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    fields={[
                      {name:"serialNo",value:currentRecord?.serialNumber},
                      {name:"quantity",value:retirementQty},
                      {name:"cost",value:currentRecord?.cost}
                    ]}
                >

        <Form.Item 
            label="Customer Group"
            name="customerGroup"
            style={{marginBottom:40}}
            rules={[
              {
                required: true,
                message: 'Customer Group is required.',
              },
             ]}>
          <Radio.Group>
            <Radio value="Residential User" disabled={currentRecord?.typeOfGreenInstrument === "SGREC"?true:false}> Residential </Radio>
            <Radio value="Business User"> C&I </Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item 
            label="Generate Certificate"
            name="generateCertificate"
            valuePropName="checked"
            rules={[
              {
                required: false,
                message: 'Generate Certificate is required.',
              },
             ]}>
          <Checkbox checked={checked} onChange={onCheckChange}></Checkbox>
        </Form.Item>

           <Form.Item
             label="Customer Name"
             name="customerName"
             wrapperCol={{
              span: 16,
              }}
                       rules={[
                        {
                          required: true,
                          message: 'Customer Name is required.',
                        },
                       ]}>
              
                        <Input/>
                    </Form.Item>

                    <Form.Item
             label="Email Address"
             name="emailAdd"
             wrapperCol={{
              span: 16,
              }}
                       rules={[
                        {
                          required: true,
                          message: 'Email Address is required.',
                        },
                        {
                          message: 'Please Input a valid Email address',
                          validator: (_, value) => {
                            if ((/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))) {
                              return Promise.resolve();
                            } else {
                              return Promise.reject('Invalid Email Address');
                            }
                        }
                         }
                       ]}>
              
                        <Input/>
                    </Form.Item>

                
                    <Form.Item
                        label="MSSL"
                        name="mssl"
                       rules={[
                        {
                          required: false,
                        },
                        {
                          message: 'MSSL should be 10 digits and start with a 9',
                          validator: (_, value) => {
                      
                            if(value && value.length>0){
                            if ((/^9\d{9}$/.test(value))) {
                              return Promise.resolve();
                            } else {
                              return Promise.reject('Invalid MSSL');
                            }
                           }else if(value=='' || value==undefined || value==null){
                            return Promise.resolve();
                           }}
                         }
                       ]}>
                            <Input/>     
                    </Form.Item>

                    <Form.Item
                        label={customerGroupValue == "Business User" ? "Business Registration No." : "Account Number"}
                        name="businessNo"
                        >
                            <Input/>     
                    </Form.Item>

                    <Form.Item
                        label="Contract Number"
                        name="contractNo"
                        wrapperCol={{
                          span: 16,
                          }}
                    >
                            <Input/>     
                    </Form.Item>
                    <Form.Item
                        label="Product Name/Description"
                        name="productName"
                        rules={[
                         {
                           required: checked ? true : false,
                           message: 'Product is required.',
                         }
                        ]}                       
                        wrapperCol={{
                          span: 16,
                          }}
                      >
                             <Select  disabled={(customerGroupValue!=undefined || customerGroupValue!=null || customerGroupValue=="") ? false : true}>
                             {energyPickedPlans.sort((a,b)=> a.planName.localeCompare(b.planName) || a.percentage - b.percentage).map((item)=>{
                                  return(
                                    <Select.Option value={JSON.stringify({energyPlanName:item.planName, energyId:item.id,percentage:item.percentage })}>{`${item.planName} ${item.planName.includes("Power Eco") || item.planName.includes("Biz Sunny") ? item.percentage : ""} ${item.isRenewal?"Renewal":""}`}</Select.Option>
                                  )
                                })}
                             
                                </Select>  
                               
                    </Form.Item>
             
                    <Form.Item
                        label={currentRecord?.typeOfGreenInstrument=="CC"?"Revenue(S$/kgCO2e)":"Revenue(S$/kWh)"}
                        name="revenue"
                       rules={[
                        {
                          required: true,
                          message: 'Revenue is required.',
                        }
                       ]}>
                            <InputNumber value={20} precision={5}/>     
                    </Form.Item>
                    <Form.Item
                        label="Retired Date"
                        name="retiredDate"
                     >
                            <DatePicker format={"DD-MM-YYYY"} disabled={true} defaultValue={moment()}/>
                    </Form.Item>
                    <Form.Item
                        label="Retirement Period Start"
                        name="retirementStart"
                     >
                            <DatePicker format={"DD-MM-YYYY"}/>     
                    </Form.Item>
                    <Form.Item
                        label="Retirement Period End"
                        name="retirementEnd"
                      >
                           <DatePicker format={"DD-MM-YYYY"} disabledDate={d => !d || d.isBefore(initialDate)} disabled={initialDate==undefined?true:false}/>      
                    </Form.Item>
                    <Form.Item
                        label={`Active ${currentRecord?.typeOfGreenInstrument} S/N`}
                        name="serialNo"
                        rules={[
                          {
                            required: true,
                            message: 'Serial Number is required.',
                          },
                         ]}
                    >
                            <Input disabled={true}/>     
                    </Form.Item>
                    <Form.Item
                        label={currentRecord?.typeOfGreenInstrument=="CC"?"Cost(S$/kgCO2e)":"Cost(S$/kWh)"}
                        name="cost"
                        rules={[
                          {
                            required: true,
                            message: 'Cost is required.',
                          },
                         ]}
                   >
                            <Input disabled={true}/>     
                    </Form.Item>
                    <Form.Item
                        label="Quantity"
                        name="quantity"
                        rules={[
                          {
                            required: true,
                            message: 'Quantity is required.',
                          },
                         ]}
                    >
                            <Input disabled={true}/>     
                    </Form.Item>
                    <Form.Item
                        label="Consumption"
                        name="Consumption"
                        rules={[
                          {
                            required: checked ? true : false,
                            message: 'Consumption is required.',
                          },
                         ]}
                    >
                            <InputNumber precision={2}/>     
                    </Form.Item>
                    <Form.Item
                        label="Remarks"
                        name="remarks"
                        wrapperCol={{
                          span: 12,
                          }}
                      >
                            <Input/>     
                    </Form.Item>
  </Form>
                </div>
            </Modal>
        </>
    );
}

export default RetirementModal;